import { dbNames } from "./db-names";
import isEmailAddress from "./is-email-address";
import isValidPassword from "./is-valid-password";

export default {
	dbNames,
	isEmailAddress,
	isValidPassword
};
